import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import CenteredSpinner from '../../libs/react-components-admin/spinners/centered-spinner';
import {defaultErrorHandler, orgId} from '../../context/context';
import shopifyThemeService from '../../services/shopify-theme-service';
import Section from '../../libs/react-components-admin/section/section';
import formService from '../../services/form-service';
import AppBlocks from './tutorials/app-blocks';
import InstructionsForShopifyOsV1 from './shopify-osv1';

const Instructions = () => {

  const [theme, setTheme] = useState();

  useEffect(() => {
    formService
      .findAllFormsCreatingDefaultIfEmpty()
      .catch(defaultErrorHandler);
    shopifyThemeService
      .findMainThemeWithAuthErrorHandling()
      .then(theme => setTheme(theme))
      .catch(err => {
        window.alert(err.stack || JSON.stringify(err));
      });
  }, []);

  if (!theme) {
    return <CenteredSpinner />;
  }
  return <div className="row justify-content-center">
    {theme.onlineStore20.supported ?
      <InstructionsForShopifyOsV2/> :
      <InstructionsForShopifyOsV1/>
    }
  </div>;
}

export default Instructions;

const InstructionsForShopifyOsV2 = () => <>
  <Section title="Quick Start" className="col-12 col-md-10 mb-4">
    <div className="row my-3">
      <div className="col text-center h5 mt-3">
        Where do you want to display your form?
      </div>
    </div>
    <div className="row justify-content-center">
      <ButtonLink path="/instructions/shopify-page-osv2">On a page</ButtonLink>
      <ButtonLink path="/instructions/shopify-product-page-osv2">On a product page</ButtonLink>
      <ButtonLink path="/instructions/shopify-cart-page-osv2">On the cart page</ButtonLink>
    </div>
  </Section>
  <Section title="Using app blocks to display a form" className="col-12 col-md-10 my-5">
    <AppBlocks/>
  </Section>
</>;

const ButtonLink = ({path, disabled, children}) => {

  const navigate = useNavigate();

  const [_disabled, setDisabled] = useState(!!disabled);

  useEffect(() => { setDisabled(!!disabled); }, [disabled]);

  return <div className="col-6 col-lg-3 mt-3 d-grid">
    <button type="button"
            className="btn btn-primary"
            onClick={() => navigate(`${path}?shop=${orgId}`)}
            disabled={_disabled}>
      {children}
    </button>
  </div>;
};
